export class JobTemplateSchedule {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cron",
            "baseName": "cron",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "comet",
            "baseName": "comet",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "useSpot",
            "baseName": "useSpot",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "forbidOverlap",
            "baseName": "forbidOverlap",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "targetSparkEngineId",
            "baseName": "targetSparkEngineId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "instanceFamily",
            "baseName": "instanceFamily",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonSparkVersion",
            "baseName": "eonSparkVersion",
            "type": "EonSparkVersion",
            "format": ""
        },
        {
            "name": "maxVcpu",
            "baseName": "maxVcpu",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxMemory",
            "baseName": "maxMemory",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxStorage",
            "baseName": "maxStorage",
            "type": "number",
            "format": ""
        },
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "customImage",
            "baseName": "customImage",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastRunAt",
            "baseName": "lastRunAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return JobTemplateSchedule.attributeTypeMap;
    }
    constructor() {
    }
}
